<script lang="ts">
    import { Row } from "sveltestrap";
    import {bookmarkId,gridClass} from "../../../store"
    import { Mybookmark } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import BookmarkDetail from "./BookmarkDetail.svelte";
    import BookmarkGrid from "./BookmarkGrid.svelte";
    let setBookmarkId:string
    bookmarkId.subscribe((value)=>{
        setBookmarkId = value
    })
    // for grid class 
    let setGridClass:boolean
    gridClass.subscribe((value)=>{
      setGridClass = value
    })
</script>
<div class="tab-pane {setBookmarkId === "pills-bookmark" ? "active" : ""}" id="pills-bookmark">
  <Card cardProps="mb-0" cardHeaderprops="d-flex" cardBodyprops="pb-0">
    <div slot="customheader" class="d-flex align-items-center justify-content-between w-100">
      <BookmarkGrid header={Mybookmark}/>
    </div>
    <div slot="contentbody">
      <div class="details-bookmark text-center {setGridClass ? "list-bookmark" : ""}">
        <Row id="bookmarkData">
          <BookmarkDetail />
        </Row>
      </div>
    </div>
  </Card>
</div>

